import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles({
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      wordBreak: "break-word"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      wordBreak: "break-word"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  saveBtn: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    alignItems: "center"
  },
  btnContainer: {
    display: "flex",
    gap: "12px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      flexDirection: "column"
    }
  }
});

export default styles;
